export default {
  small: '(min-width: 480px)',
  medium: '(min-width: 700px)',
  large: '(min-width: 960px)',
}
